module.exports = " <footer class=\"c-footer u-gutter\" role=contentinfo> <a href=https://github.com/wovue/component-template/tree/master target=_blank rel=\"noopener noreferrer\">Wovue component template</a> <a href=https://github.com/SassDoc/sassdoc-theme-default target=_blank rel=\"noopener noreferrer\">SassDoc Default Theme</a> </footer> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-docs/app/shared/components/AppFooter.vue
 ** module id = 90
 ** module chunks = 1
 **/